import { combineReducers } from "redux";
import {reducer as toastrReducer} from "react-redux-toastr";
import appInfo from "./appReducer";
import dataInfo from "./filterReducer";

const rootReducer = combineReducers({appInfo, dataInfo, toastr: toastrReducer});

export default rootReducer;
